<template>
  <v-container>
    <v-col align="center" align-self="center">
      <v-col class="mb-4">
        <v-row
          class="ma-0 mb-2 section-heading"
          align="center"
          justify="center"
        >
          <v-img
            class="me-3"
            max-width="46px"
            max-height="46px"
            aspect-ratio="1"
            src="@/assets/certificate/checkOneCertificateGroup.svg"
          />
          Congratulations! Your registration is successful
        </v-row>

        <v-col class="pa-0 sub-text" align="center">
          You have been given access to premium membership until
          {{ membershipValidTill }}. Through this membership you can attend the
          upcoming sessions under the module for free.
          <br />

          You will be receiving emails in your inbox to register for each
          module/workshop of the program.
        </v-col>
      </v-col>
      <ul class="StepProgress">
        <!-- <li class="StepProgress-item">
          <v-col align="left" class="ma-0 mb-2 pt-0 section-heading">
            Congratulations! You’re now a Premium Member
          </v-col>
          <v-col class="pt-0 sub-text" align="left">
            Your membership starts today and will expire on -
            {{ membershipValidTill }}
          </v-col>
        </li> -->
        <li class="StepProgress-item">
          <UpcomingWorkshop />
        </li>
        <li class="StepProgress-item">
          <ReferralCard />
        </li>
        <li class="StepProgress-item">
          <MembershipBenefits />
        </li>
        <li class="StepProgress-item">
          <MembershipFAQ />
        </li>
      </ul>
    </v-col>
  </v-container>
</template>

<script>
  import AmplitudeHelper from "../../../amplitude";
  import ShareHelper from "../../../helper/share";
  import { ROUTER_URL } from "../../../constants/urls";
  import store from "../../../store";
  import authToken from "../../../common/authToken";
  import Helper from "../../../helper";

  import MembershipBenefits from "../../../components/Membership/ThankYou/MembershipThankYouBenefits";
  import MembershipFAQ from "../../../components/Membership/ThankYou/MembershipFAQ";
  import UpcomingWorkshop from "../../../components/Membership/ThankYou/UpcomingWorkshop";
  import ReferralCard from "../../../components/Membership/ThankYou/ReferralCard";

  export default {
    name: "PublicMembershipThankYou",
    components: {
      MembershipBenefits,
      MembershipFAQ,
      UpcomingWorkshop,
      ReferralCard,
    },
    data() {
      return {
        membershipValidTill: Helper.formatDashedDate(
          authToken.decodedToken().membership_validity.replace(/\s/, "T")
        ),
        display: false,
        whatsappUrl: "",
        faqs: [
          {
            question: "How do I know if this membership is right for me?",
            answer:
              "The membership is designed for special educators like you. If you're planning to become better at what you do, we have curated learning paths, hands-on workshops & much more for you in the membership!",
          },
          {
            question:
              "I cannot afford the membership, how do I grow in as a special educator?",
            answer:
              "We host a lot of free webinars and have hundreds of resources openly available for you to learn. If there's a paid workshop you could really benefit from but can't afford it, please write to us at support@eblity.com.",
          },
          {
            question:
              "Can I get a free trial, what if I am not satisfied with the membership?",
            answer:
              "Even though we don't have a free trial, you could opt for a monthly membership and if you aren't satisfied with it, we'll offer you a full refund, no questions asked.",
          },
          {
            question:
              "Can I watch previous webinars and workshops to see if I like them?",
            answer:
              "Yes, you can watch our webinars on our YouTube channel here. Our workshops are designed to be hands-on and practical, you can check our upcoming workshops here.",
          },
        ],
        steps: [
          {
            image: "@/assets/membership/membershipOnboarding.svg",
            title: "Complete membership onboarding",
            description: "Check your email for log in details",
          },
          {
            image: "@/assets/membership/onOurPlatform.svg",
            title: "Sign up on our platform",
            description: "Do a 2-min sign up to access the platform",
          },
          {
            image: "@/assets/membership/enjoyTheBenefits.svg",
            title: "Enjoy the benefits",
            description:
              "That's it, you're now an Eblity member with unlimited benefits!",
          },
        ],
      };
    },
    created() {
      if (this.$store.state.membership.userMembership) {
        console.log("ok");
        var param = {};
        var thankyouParam = {};

        if (this.$store.state.sessionSeriesDetails.data) {
          param = {
            "workshop name": this.$store.state.sessionSeriesDetails.data.title,
          };
          thankyouParam = {
            "workshop name": this.$store.state.sessionSeriesDetails.data.title,
          };
        }
        if (this.$store.state.isMembershipEnabled) {
          if (this.$store.state.membership.isRenewMembership) {
            param["membership type"] = "renewal";
            thankyouParam["type"] = "renewal";
          } else if (this.membershipDetails.price == 0) {
            param["membership type"] = "free";
            thankyouParam["type"] = "free";
          } else {
            param["membership type"] = "new";
            thankyouParam["type"] = "new";
          }
        }

        AmplitudeHelper.registerAmplitudeEvent(
          "view membership thank you page",
          thankyouParam
        );
      } else {
        this.$router.push({
          name: ROUTER_URL.publicSession.children.webinarList.name,
        });

        // this.$store.state.membership.userMembership = {
        //   id: 9,
        //   user_details: {
        //     id: 107,
        //     registered_email: "sdsdsdvvvdf@test.lol",
        //     mobile: 66337722898,
        //     otp: 0,
        //     name: "Abhishek Tupparwar",
        //     first_name: "Abhishek",
        //     last_name: "Tupparwar",
        //     is_eblity_admin: false,
        //     is_active: true,
        //     user_group: 6,
        //     created: "2021-02-16T16:07:50.588785Z",
        //     modified: "2021-02-16T16:07:50.588832Z",
        //   },
        //   plan_details: {
        //     id: 3,
        //     name: "Yearly",
        //     display_price: 4999.0,
        //     benefits: "",
        //     currency_details: {
        //       id: 68,
        //       name: "INR",
        //       symbol: "₹",
        //       created: "2021-02-16T09:42:17.710454Z",
        //       modified: "2021-02-16T09:42:17.710557Z",
        //     },
        //     price: 14999.0,
        //     validity_period: 365,
        //     type: "Annually",
        //     status: "Active",
        //     created: "2021-02-16T15:57:44.971239Z",
        //     modified: "2021-02-16T15:57:46.934866Z",
        //   },
        //   transaction_details: {
        //     id: 62,
        //     payment_id: null,
        //     payment_status: "Pending",
        //     currency_code: "INR",
        //     first_name: "Abhishek",
        //     last_name: "Tupparwar",
        //     email: "sdsdsdvvvdf@test.lol",
        //     mobile: 66337722898,
        //     address: null,
        //     amount: 14999.0,
        //     order_id: null,
        //     payment_type: "Membership",
        //     created: "2021-02-16T16:07:56.979610Z",
        //     modified: "2021-02-16T16:07:56.979667Z",
        //     user: 107,
        //     payment_mode: 3,
        //     product_type: 2,
        //   },
        //   activated_date_time: "2021-02-16T16:07:56.983154Z",
        //   expiry_date_time: "2022-02-16T16:07:56.982319Z",
        //   name: "Yearly",
        //   price: 14999.0,
        //   validity_period: 365,
        //   status: "Activated",
        //   created: "2021-02-16T16:07:56.983277Z",
        //   modified: "2021-02-16T16:07:56.983297Z",
        // };
      }
    },
    computed: {
      membershipDetails() {
        return this.$store.state.membership.userMembership;
      },
    },
    watch: {},
    methods: {
      emailShare() {
        AmplitudeHelper.registerEvent(
          "Membership - Share - Email",
          this.membershipDetails
        );
        window.location =
          "mailto:?body=" +
          this.makePublicLink() +
          "&subject=I thought this link might interest you.";
      },
      makePublicLink() {
        let props = this.$router.resolve({
          name: ROUTER_URL.publicMembership.children.membershipBenefits.name,
        });
        return window.location.origin + props.href;
      },
      copyLink() {
        var text = window.location.href;
        let props = this.$router.resolve({
          name: ROUTER_URL.publicMembership.children.membershipBenefits.name,
        });
        console.log(props);
        text = window.location.origin + props.href;
        // text = text.replace("app", "parent");
        var dummy = document.createElement("input");
        document.body.appendChild(dummy);
        dummy.value = text;
        dummy.select();
        document.execCommand("copy");
        document.body.removeChild(dummy);
        store.dispatch("snackBar/showToast", {
          message: "Share link copied.",
          color: "S",
        });
      },
      facebookShare() {
        AmplitudeHelper.registerEvent(
          "Membership - Share - Facebook"
          // this.sessionDetails
        );

        ShareHelper.onFacebook({
          link: this.makePublicLink(),
          text: this.getShareText(),
        });
      },
      twitterShare() {
        AmplitudeHelper.registerEvent(
          "Membership - Share - Twitter"
          // this.sessionDetails
        );

        ShareHelper.onTwitter({
          url: this.makePublicLink() + "\n\n ",
          text: this.getShareText(),
          tag: "Workshop",
        });
      },
      getShareText() {
        var text = "";
        text =
          "I recommend you to watch this workshop. It has some amazing things to learn from.";
        return text;
      },
      getFormatDate(date, is_timestamp) {
        date = new Date(date);

        // let now = new Date();

        if (is_timestamp) {
          return date;
        } else {
          var monthNames = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ];

          date =
            date.getDate() +
            " " +
            monthNames[date.getMonth()] +
            " " +
            date.getFullYear();

          return date;
        }
      },
    },
    mounted() {
      this.whatsappUrl =
        "whatsapp://send?text=" +
        this.getShareText() +
        "%0a" +
        this.makePublicLink();
    },
  };
</script>

<style scoped>
  .section-heading {
    font-weight: 900;
    font-size: 36px;
    line-height: 50px;
    color: #333333;
  }

  .sub-text1 {
    font-weight: 500;
    font-size: 16px;
    color: #5271ff;
  }

  .sub-text2 {
    font-weight: 500;
    font-size: 21px;
    color: rgba(51, 51, 51, 0.7);
  }

  .StepProgress {
    position: relative;
    padding-left: 45px;
    list-style: none;
    max-width: 740px;
  }
  .StepProgress::before {
    display: inline-block;
    content: "";
    position: absolute;
    top: 0;
    left: 18px;
    width: 10px;
    height: 100%;
    border-left: 2px dashed #ccc;
  }
  .StepProgress-item {
    position: relative;
    counter-increment: list;
  }
  .StepProgress-item:not(:last-child) {
    padding-bottom: 80px;
  }
  .StepProgress-item::before {
    display: inline-block;
    content: "";
    position: absolute;
    /* left: -30px; */
    height: 100%;
    width: 10px;
  }
  .StepProgress-item::after {
    display: inline-block;
    position: absolute;
    border-radius: 50%;

    content: counter(list);
    padding-top: 10px;
    width: 48px;
    height: 48px;
    top: 0px;
    left: -50px;
    font-weight: 900;
    font-size: 20px;
    line-height: 27px;
    text-align: center;
    color: white;
    border: 2px solid #5271ff;
    background-color: #5271ff;
  }

  .StepProgress strong {
    display: block;
  }
</style>
